"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useSendMessage;

var _useWebChatAPIContext = _interopRequireDefault(require("./internal/useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useSendMessage() {
  return (0, _useWebChatAPIContext.default)().sendMessage;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VTZW5kTWVzc2FnZS50cyJdLCJuYW1lcyI6WyJ1c2VTZW5kTWVzc2FnZSIsInNlbmRNZXNzYWdlIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7QUFFZSxTQUFTQSxjQUFULEdBSUw7QUFDUixTQUFPLHFDQUF1QkMsV0FBOUI7QUFDRCIsInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHVzZVdlYkNoYXRBUElDb250ZXh0IGZyb20gJy4vaW50ZXJuYWwvdXNlV2ViQ2hhdEFQSUNvbnRleHQnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB1c2VTZW5kTWVzc2FnZSgpOiAoXG4gIHRleHQ6IHN0cmluZyxcbiAgbWV0aG9kPzogc3RyaW5nLFxuICB7IGNoYW5uZWxEYXRhIH0/OiB7IGNoYW5uZWxEYXRhPzogYW55IH1cbikgPT4gdm9pZCB7XG4gIHJldHVybiB1c2VXZWJDaGF0QVBJQ29udGV4dCgpLnNlbmRNZXNzYWdlO1xufVxuIl19